import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { STORE } from '@/core/store/core.store';
import { IAddPaperUpdated } from '@/templates/interfaces/add-paper-updated.interface';
import { IPaperSelected } from '@/templates/interfaces/paper-selected.interface';
import { PAPER_SELECTED_TYPES, _TEMPLATES_STORE } from '@/templates/values/templates.values';
import { IParamsPaperWriteObject } from '@/templates/interfaces/params-paper-write-object.interface';
import { PaperTypeItem } from '@/templates/models/paper-type-item.model';
import EdPaperTypeItem from '@/templates/components/ed-paper-type-item/ed-paper-type-item.vue';
import EdPdfViewer from '@/components/common/ed-pdf-viewer/ed-pdf-viewer.vue';

@Component({
  components: {
    EdAddPaperWriteObject: () => import(/* EdAddPaperWriteObject */'../ed-add-paper-write-object/ed-add-paper-write-object.vue'),
    EdPaperTypeItem,
    EdPdfViewer,
  }
})
export default class EdPapersWriteObject extends Vue {

  @Prop() readonly setPaper: any;
  @Prop() readonly params: IParamsPaperWriteObject;

  public userpp: any[];
  public paperAdded: IAddPaperUpdated = { success: false };
  public menuOpened: string = '';
  public menuOptions: any = {
    eduac: {
      name: PAPER_SELECTED_TYPES.EDUAC_PAPER,
      loading: false
    },
    user: {
      name: PAPER_SELECTED_TYPES.USER_PAPER,
      loading: false
    },
    add: PAPER_SELECTED_TYPES.UPLOAD,
    none: PAPER_SELECTED_TYPES.NONE
  };

  get eduacPapers() {
    return this.$store.state.TemplatesStore.eduacPapers.content;
  }

  get userPapers() {
    return this.$store.state.TemplatesStore.userPapers.content;
  }

  get paperSelected() {
    return this.$store.state.TemplatesStore.paperSelected;
  }

  async openPapersMenu(value: string) {
    this.$store.commit(_TEMPLATES_STORE.MUTATIONS.RESET_USER_PAPERS_LOAD);
    try {
      if(value !== this.menuOpened) {
        this.menuOpened = value;
        switch(value) {
          case this.menuOptions.eduac.name:
            if(!this.$store.state.TemplatesStore.eduacPapers.load) {
              this.menuOptions.eduac.loading = true;
              await this.$store.dispatch(_TEMPLATES_STORE.ACTIONS.GET_EDUAC_PAPERS);
              this.userpp = this.$store.state.TemplatesStore.userPapers.content;
              this.menuOptions.eduac.loading = false;
            } 
            if(this.params.edition && !this.paperSelected) {
              this.$store.commit(_TEMPLATES_STORE.MUTATIONS.SET_EDUAC_PAPER_SELECTED, this.params.paperId);
            } else {
              this.$store.commit(_TEMPLATES_STORE.MUTATIONS.SET_EDUAC_PAPER_SELECTED, null);
            }
          break;
          case this.menuOptions.user.name:
            if(!this.$store.state.TemplatesStore.userPapers.load) {
              this.menuOptions.user.loading = true;
              await this.$store.dispatch(_TEMPLATES_STORE.ACTIONS.GET_USER_PAPERS);
              this.menuOptions.user.loading = false;
            }
            if(this.params.edition && !this.paperSelected) {
              this.$store.commit(_TEMPLATES_STORE.MUTATIONS.SET_USER_PAPER_SELECTED, this.params.paperId);
            } else {
              this.$store.commit(_TEMPLATES_STORE.MUTATIONS.SET_USER_PAPER_SELECTED, null);
            }
          break;
        }
      } else {
        this.menuOpened = this.menuOptions.none;
      }
      this.updatePaper();
    } catch(err) {
      this.menuOptions.user.loading = false;
      this.menuOptions.eduac.loading = false;
    } finally {
      //verify if selected paper (this.params.paperId) is already loaded
      //user papers are not loaded by default when paper was created by another user
      const paperIsAlreadyLoaded = [].concat(this.eduacPapers, this.userPapers).find(item => item.templateId == this.params.paperId);
      const isPaperSelected = this.params.paperId;
      if( paperIsAlreadyLoaded || !isPaperSelected) {
        //if paper is already loaded or there is not paper selected then do nothing
      } else {
        //if paper was not loaded then retrive it from selected section object as a user's paper
        this.$store.commit(_TEMPLATES_STORE.MUTATIONS.ADD_USER_PAPERS, {
          templateId: this.params.paperId,
          name: this.params.name,
          selected: false,
          imageUrl: this.params.coverFile,
          templateUrl: this.params.paperFile,
        });
        this.$store.commit(_TEMPLATES_STORE.MUTATIONS.SET_USER_PAPER_SELECTED, this.params.paperId);
        this.updatePaper();
      }
    }
  }

  onPaperUploaded(data: IAddPaperUpdated) {
    this.paperAdded = data;
    this.$store.state.TemplatesStore.userPapers.load && 
      this.$store.commit(_TEMPLATES_STORE.MUTATIONS.RESET_USER_PAPERS_LOAD);
    this.updatePaper();
  }

  selectPaper(paper: PaperTypeItem) {
    this.$store.commit(_TEMPLATES_STORE.MUTATIONS.CLEAR_PAPER_SELECTED);
    setTimeout(() => {
      if(this.menuOpened == this.menuOptions.eduac.name) {
        this.$store.commit(_TEMPLATES_STORE.MUTATIONS.SET_EDUAC_PAPER_SELECTED, paper.templateId);
      } else {
        this.$store.commit(_TEMPLATES_STORE.MUTATIONS.SET_USER_PAPER_SELECTED, paper.templateId);
      }
      this.updatePaper();
    });
  }

  updatePaper() {
    let data: IPaperSelected = { type: PAPER_SELECTED_TYPES.UNDEF };
    switch(this.menuOpened) {
      case this.menuOptions.eduac.name:
        if(this.paperSelected) {
          data.type = PAPER_SELECTED_TYPES.EDUAC_PAPER;
          data.paperId = this.paperSelected.templateId;
        }
      break;
      case this.menuOptions.user.name:
        if(this.paperSelected) {
          data.type = PAPER_SELECTED_TYPES.USER_PAPER;
          data.paperId = this.paperSelected.templateId;
        }
      break;
      case this.menuOptions.add:
        if(this.paperAdded.success) {
          data.type = PAPER_SELECTED_TYPES.UPLOAD;
          data.coverFile = this.paperAdded.cover;
          data.paperFile = this.paperAdded.paper;
        }
      break;
      default:
        data = { type: PAPER_SELECTED_TYPES.NONE };
      break;
    }
    this.$emit('setPaper', data);
  }

  mounted() {
    if(this.params.edition) {
      this.openPapersMenu(this.params.type);
      return;
    }
    this.openPapersMenu(this.menuOptions.none);
  }

}